import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ArrowLeft } from "react-feather";
import i18next from "i18next";
import {
    CustomerAreaContext,
    ACTIONS,
    PAGES,
} from "../../CustomerAreaProvider";

const GoBackTitle = ({ path }) => {
    const { dispatch } = useContext(CustomerAreaContext);
    const redirectPage =
        path === PAGES.ORDER_DETAIL ? PAGES.ORDERS_OVERVIEW : PAGES.OVERVIEW;

    const handleGoBack = () =>
        dispatch({ type: ACTIONS.CHANGE_PAGE, payload: redirectPage });

    return (
        <div className="go-back-title">
            <div className="arrow-wrapper" onClick={handleGoBack}>
                <ArrowLeft size={24} />
            </div>
            <span className="title">
                {i18next.t(`customerArea.nav.${path}`)}
            </span>
        </div>
    );
};

GoBackTitle.propTypes = {
    path: PropTypes.string,
};

export default GoBackTitle;
